import {version,displayName} from '../../../../package.json'

const Metadata = {
	version: version,
	name: displayName,
}

export default Metadata
